import {Stack} from 'src/design/atoms/Stack';
import React from 'react';

import {BackBar} from 'src/app/layout/BackBar';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {PageHeader} from 'src/design/organisms/PageHeader';
import {FormViewComponentV2Example} from 'src/app/forms/FormViewComponent/FormViewComponentV2.example';
import {SidebarLinkTestArea} from 'src/app/layout/Sidebar/SidebarLinksConfig';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';

export const ViewTestFormPage: React.FC = () => {
  return (
    <ContentWrapper>
      <Stack gap="lg">
        <BackBar
          fallbackTo={PathUtility.AdminTestArea()}
          fallbackLabel="Back to Test Area"
          breadcrumbs={[
            {label: 'System', to: PathUtility.AdminSystem()},
            {label: 'Test Area', to: PathUtility.AdminTestArea()},
            {label: 'View Test Form'},
          ]}
        />
        <PageHeader>
          <PageHeader.Title
            icon={SidebarLinkTestArea.icon}
            subtitle="FormViewComponentV2 demonstration">
            View Test Form
          </PageHeader.Title>
        </PageHeader>
        <FormViewComponentV2Example />
      </Stack>
    </ContentWrapper>
  );
};

routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: PathUtility.AdminViewTestForm(),
  element: <ViewTestFormPage />,
  isPrivate: true,
  requireSuperAdmin: true,
});

export default ViewTestFormPage;
